<script>
export default {
  name: "car_types_information",
  props: ['carTypes'],
}
</script>

<template>
  <div class="d-flex w-100">
    <div class="me-3" v-if="carTypes.length"><strong>車両</strong></div>
    <div class="d-flex gap-2 flex-wrap">
      <h4 v-for="(item, index) in carTypes" :key="`carType${index}`">
        <span class="badge bg-success">{{ item.invoice_product_name }} × {{ item.number_of_cars }}</span>
      </h4>
    </div>
  </div>
</template>

<style scoped>

</style>
